import React from 'react';
import Container from './Container';
import Sparkle from './Sparkle';
import Eyebrow from './Eyebrow';

const cx = (...c) => c.filter(Boolean).join(' ');

const TINT = { lilac: 'bg-sky', peach: 'bg-cream', blush: 'bg-cream', sage: 'bg-sky', cream: 'bg-cream' };

/** Reusable inner-page hero on a soft tint. */
const PageHero = ({
  eyebrow, title, lead, tint = 'lilac', align = 'left', children, className,
}) => (
  <section className={cx('relative overflow-hidden', TINT[tint], className)}>
    <Sparkle size={120} color="#95a8e6" className="pointer-events-none absolute -top-6 right-[6%] opacity-20 hidden sm:block" />
    <Sparkle size={56} color="#ffb442" className="pointer-events-none absolute bottom-[14%] left-[5%] opacity-70" />
    <Container className="relative py-16 md:py-24">
      <div className={cx('max-w-[60ch]', align === 'center' && 'mx-auto text-center')}>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h1 className="mt-4 text-h1 font-extrabold text-ink">{title}</h1>
        {lead && <p className={cx('mt-5 text-lead text-body max-w-[52ch]', align === 'center' && 'mx-auto')}>{lead}</p>}
        {children && <div className={cx('mt-8 flex flex-wrap gap-3.5', align === 'center' && 'justify-center')}>{children}</div>}
      </div>
    </Container>
  </section>
);

export default PageHero;
